import { render, staticRenderFns } from "./button-block.vue?vue&type=template&id=39ff4bc7"
import script from "./button-block.vue?vue&type=script&lang=js"
export * from "./button-block.vue?vue&type=script&lang=js"
import style0 from "./button-block.vue?vue&type=style&index=0&id=39ff4bc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports